import React, {FC} from 'react';
import styled from 'styled-components';

import {PaletteColorsEnum} from '../../../../libs/shared/core/src/models/api/paletteModel';
import {collectEnumValues} from '../../../../libs/shared/core/src/models/api/types/enumTypes';
import {UserTheme} from '../../../../libs/shared/ui/src/theme/themeTypes';
import {useUserTheme} from '../../../../libs/shared/ui/src/theme/userThemeProvider';
import {PaletteColorPickerItem} from './paletteColorPickerItem';

/*
 * Props.
 */

export interface PaletteColorPickerProps {
  paletteColor?: PaletteColorsEnum;
  onColorSelect: (arg: PaletteColorsEnum) => void;
  itemsSize?: number;
  colorItems?: ReadonlyArray<PaletteColorsEnum>;
  className?: string;
  isDisabled?: boolean;
}

/*
 * Types.
 */

interface ColorItem {
  key: string;
  paletteColor: PaletteColorsEnum;
  color: string;
  isDisabled?: boolean;
}

/*
 * Style.
 */

const StyledPickerDiv = styled.div`
  display: grid;
  grid-auto-flow: column;
  grid-gap: 3px;
`;

export const PaletteColorPicker: FC<PaletteColorPickerProps> = (props) => {
  const theme = useUserTheme();
  const colorItems = buildColorItems(theme, props.colorItems);
  return (
    <StyledPickerDiv className={props.className}>
      {colorItems.map((item) => renderItem(props, item))}
    </StyledPickerDiv>
  );
};

function buildColorItems(theme: UserTheme, customColorItems?: ReadonlyArray<PaletteColorsEnum>) {
  const colorItems: Array<ColorItem> = (customColorItems ?? collectEnumValues(PaletteColorsEnum)).map(
    (v) => ({
      key: theme.palette[v].shade40,
      paletteColor: v,
      color: theme.palette[v].shade40,
    }),
  );

  return colorItems;
}

function renderItem(props: PaletteColorPickerProps, item: ColorItem) {
  const {key, paletteColor, color} = item;
  return (
    <PaletteColorPickerItem
      key={key}
      size={props.itemsSize}
      color={color}
      isSelected={props.paletteColor === paletteColor}
      isDisabled={props.isDisabled}
      onClick={() => !props.isDisabled && props.onColorSelect(paletteColor)}
    />
  );
}
